import React, { PropTypes } from 'react'
import NavLink from '../router/NavLink'
import MultiLangText from '../multilang/MultiLangText'
import {TimelineMax,TweenLite, Linear, Power2, Power3, Power4 ,Back, Circ} from 'gsap'
import ScrollArrow from '../scrollarrow/ScrollArrow'



class TextRow extends React.Component {


  constructor(){

    super();
    this.state = {
      showScrollArrow:false
    }
    this.animateOpening = this.animateOpening.bind(this);
    this.checkCopyWidth = this.checkCopyWidth.bind(this)

    this.scrollSpy = this.scrollSpy.bind(this);
  }


  animateOpening(){




    let title = this.refs.container.querySelector('.description .title')
    let line  = this.refs.container.querySelector('.description .line')
    let copy = this.refs.container.querySelector('.description .copy')

    let brandTab =  this.refs.container.querySelector('.kastner-brand-tab')

    let copyCover = this.refs.container.querySelector('.description .copy .gradient')

    let open_tl = new TimelineMax({repeat:0})
          open_tl.from(title,1,{alpha:0},'0')


          open_tl.add(()=>{
                this.checkCopyWidth();
          })

          open_tl.from(line,1,{scaleX:0,ease:Power3.easeOut},'-=1');





          open_tl.fromTo(copyCover,2,{top:'-100%'},{top:'100%'})


          open_tl.add(()=>{
            this.setState({showScrollArrow:true})
          },'-=.7')
          open_tl.pause();

          this.setState({open_tl})

  }

  checkCopyWidth(){

    let copy = this.refs.container.querySelector('.description .copy');
    let copyParent = this.refs.container.querySelector('.description');

        copy.classList.remove('small-screen')





        //console.log(copy.offsetWidth,copyParent.offsetWidth);

        if(copy.offsetWidth>copyParent.offsetWidth-40){
            copy.classList.add('small-screen')
        }


  }

  componentDidMount(){
    this.animateOpening();

    window.addEventListener('scroll',this.scrollSpy)
    window.addEventListener('resize',this.checkCopyWidth)
  }

  componentWillUnmount(){
    window.removeEventListener('scroll',this.scrollSpy)
    window.removeEventListener('resize',this.checkCopyWidth)

  }



  scrollSpy(){

    let scrollTarget = this.refs.container.getBoundingClientRect()

        //console.log(scrollTarget.top , window.innerHeight*.3);

        if(scrollTarget.top !==0 && scrollTarget.top < window.innerHeight*.3){
          this.state.open_tl.play()
          console.log("Animate Text");
          window.removeEventListener('scroll',this.scrollSpy)
        }
  }


  render(){


    let arrowStyle = {}

    if(window.innerWidth < 769){
        arrowStyle = {
          top:'auto',//(this.state.screenHeight - 110)+'px'
          bottom:'50px'
        }


    }


    return(
      <div className="text-row" ref="container">
          <div className="description"  >

              <div className="inner">

                <h5 className="title"><MultiLangText text={this.props.text_row_title} /></h5>
                <div className="line" />
                <div className="copy"  >
                    <div>

                      {
                        <MultiLangText text={this.props.text_group} />
                      }
                    </div>
                    <div className="cover">
                        <div className="gradient" />
                    </div>
                </div>
              </div>
              {(this.state.showScrollArrow)?
                <ScrollArrow className="mobile-arrow" style={arrowStyle} />
              : null }

            </div>
            <div className="scroll-anchor" />
        </div>
    )
  }
}
export default TextRow;



// WEBPACK FOOTER //
// ./src/modules/work/TextRow.js